export const STORE_TYPE_PARTNER = 2;

// Caravel store records that are real (linked staff, valid coordinates, so they
// survive the export-time data-quality filter) but are not physical showrooms
// customers can visit. They must never appear as a search result on the header,
// footer, mobile nav, or full locator page. Match on id first (stable) and fall
// back to name (in case an id ever shifts upstream).
//
// CON-8186: Virtual Store (id=5, name="Virtual Store", rs_domain_name="Virtual
// Showroom") is promoted separately via the locator page's VirtualShowroomBlock.
export const VIRTUAL_STORE_ID = 5;

// CS Sales (id=15, "Customer Service" in the store-mode hostname map) is the
// phone sales team. It shares DTLA's street address, so a zip search near 90021
// surfaced both, and it has no landing page of its own — a result for it would
// link nowhere.
export const CS_SALES_STORE_ID = 15;

const NON_SHOWROOM_STORE_IDS = [VIRTUAL_STORE_ID, CS_SALES_STORE_ID];

const NON_SHOWROOM_STORE_NAMES = [
  'Virtual Store',
  'Virtual Showroom',
  'CS Sales',
  'Customer Service',
];

const normalizeStoreId = id => {
  if (typeof id === 'number') return Number.isInteger(id) ? id : null;
  if (typeof id === 'string' && id.trim() !== '') {
    const parsed = Number(id);
    return Number.isInteger(parsed) ? parsed : null;
  }
  return null;
};

export const isPhysicalShowroom = store => {
  if (!store) return false;
  if (NON_SHOWROOM_STORE_IDS.includes(normalizeStoreId(store.id))) return false;
  if (NON_SHOWROOM_STORE_NAMES.includes(store.name)) return false;
  return true;
};

export const BANNER_IMAGE_URL =
  'https://joybird2.imgix.net/public_img/static-v1/store-locator/storelocator-banner-v2.jpg';

export const toStoreEntry = row => {
  if (!row) return null;
  if (row.storeData) {
    return {
      store: row.storeData,
      distance: typeof row.distance === 'number' ? row.distance : null,
    };
  }
  return { store: row, distance: null };
};

export const groupStoresByType = (stores = []) => {
  const showrooms = [];
  const partnerStudios = [];
  stores.forEach(store => {
    if (store?.type === STORE_TYPE_PARTNER) {
      partnerStudios.push(store);
    } else {
      showrooms.push(store);
    }
  });
  return { showrooms, partnerStudios };
};

export const groupStoresByState = (stores = []) => {
  const grouped = stores.reduce((acc, store) => {
    const state = store?.state || 'Other';
    if (!acc[state]) acc[state] = [];
    acc[state].push(store);
    return acc;
  }, {});

  return Object.keys(grouped)
    .sort()
    .reduce((acc, state) => {
      acc[state] = grouped[state]
        .slice()
        .sort((a, b) => (a?.name || '').localeCompare(b?.name || ''));
      return acc;
    }, {});
};

export const buildDirectionsUrl = store => {
  const parts = [store?.street, store?.city, store?.state, store?.zip].filter(
    Boolean
  );
  const destination = encodeURIComponent(parts.join(', '));
  return `https://www.google.com/maps/dir/?api=1&destination=${destination}`;
};

export const buildDetailUrl = store => {
  if (store?.slug) {
    return store.slug.startsWith('/') ? store.slug : `/${store.slug}`;
  }
  return '/showrooms/';
};
